module.exports = __webpack_public_path__ + "static/media/Portfolio.4ec06ac3.scss";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/portfolio/Portfolio.scss
// module id = 230
// module chunks = 0